import React, { useCallback, useEffect, useState } from 'react';
import { getEntityList, getQueryStrinngFromObject, getRequestData } from '../../../Utility/apiHelper';
import moment from 'moment';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import AuditSearch from './SearchAudit';
import GeneralDialog from '../../../Components/Dialog';
import { entitylist, handleValidateCodevalue } from '../../../Utility/constant';
import { useSelector } from 'react-redux';
import { Stack, Tooltip, Typography } from '@mui/material';
import {useSnackbar} from 'notistack';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Table } from 'antd';
import { StyledflexSpacebetween, StyledIndexContainerDiv, StyledLeadContainer } from '../../../Components/Styled';
import ReactDiffViewer from 'react-diff-viewer'
import { useDispatch } from 'react-redux';
import { handleRequestSearchAuditLogs } from '../../../Store/audit/action';
import BiztantuSearch from '../../../Components/BiztantuSearch';
import BiztantuLoader from '../../../Components/Loader';
import { requestHideLoader, requestShowLoader } from '../../../Store/Global/action';
import './audit.css';

const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {
  },
  onSelect: (record, selected, selectedRows) => {
  },
  onSelectAll: (selected, selectedRows, changeRows) => {
  },
};

// ["Lead","LeadFollowup","LeadProduct", "Order", "Customer"]

const entityPriority = {
  Lead: 1,
  // LeadFollowup: 2,
  // LeadProduct: 3,
  // Customer: 4,
  // Order:5,
  
};

export const AuditLogs = ({label="AUDI_SEARCH_TITLE", isSearchRequired = true, entityDetails = {module: "All"} }) => {

    const [originalrecord, setoriginalRecord] = useState([]);
    const [datagridData, setDatagridData] = useState([]);
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);

    // Date fields removed from search per PRD — only entity + entityId remain
    const [inputSearch, setInputSearch] = useState({
        entityId: null,
        entity: null,
    });

    const auditStoreData = useSelector(state => state?.audit.AuditData);
    const auditSearchPayload = useSelector(state => state?.audit?.auditSearchPayload);

    useEffect(() => {
      if (isSearchRequired) {
        const groupedData =  groupByEntityWithChildren(auditStoreData);

                const sortedbasedonTime = groupedData.map(item => {
                  return {
                    ...item,
                    children: item?.children?.sort((a,b) => new Date(b?.createdAt) - new Date(a?.createdAt))
                  }
                });
        setoriginalRecord(auditStoreData);
        setDatagridData(sortedbasedonTime);
      } else if (entityDetails?.entity && entityDetails?.entityId) {
        const currentEntities = getEntityList(entityDetails);
        const requestedEntities = Array.isArray(auditSearchPayload?.entity) ? auditSearchPayload?.entity : [auditSearchPayload?.entity];
        const isSameEntityId = String(auditSearchPayload?.entityId) === String(entityDetails?.entityId);
        const isSameEntity = currentEntities.length > 0 && currentEntities.every(entity => requestedEntities.includes(entity));

        if (isSameEntityId && isSameEntity) {
          setDatagridData(auditStoreData);
          setoriginalRecord(auditStoreData);
        }
      }
    },[auditStoreData, auditSearchPayload, entityDetails?.entity, entityDetails?.entityId, isSearchRequired])

    const dispatch = useDispatch();

    const [requiredError, setRequiredError] = useState({
        entityId: false,
        entity: false,
    });

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData);


    useEffect(() => {
      if (entityDetails?.module === "All") {
          handleGetAllLogs();
      } else if (!isSearchRequired && entityDetails?.entity && entityDetails?.entityId) {
          handleGetEntityLogs();
      } else if (!isSearchRequired) {
          setDatagridData([]);
          setoriginalRecord([]);
      }
    }, [entityDetails?.module, entityDetails?.entity, entityDetails?.entityId, isSearchRequired])


    const getDifferences = (oldJson, newJson) => {
        const diffs = [];
        for (const key in newJson) {
          if (oldJson[key] !== newJson[key]) {
            diffs.push(key);
          }
        }
        return diffs;
    };
      


    const differingKeys = getDifferences(datagridData?.newdata, datagridData?.oldData);

  // Style customization function for specific keys/values
    const customStyle = ({ name, value }) => {
        if (differingKeys.includes(name)) {
        return { backgroundColor: "#ffeb3b", fontWeight: "bold", color: "#d32f2f" }; // Highlight style
        }
        return {};
    };

    const groupByEntityWithChildren = (logs) => {
      
      return (logs || []).reduce((groups, log) => {
          const { entityId, entity, newData, oldData, createdAt, clientName, action, userName, key, id } = log;
          
          if (entityId === null) {
            groups.push({ entityId, entity, newData, oldData, createdAt, clientName, action, userName, id });
            return groups;
          }

          let parentEntity = entitylist[entity];
         
          if (!groups.some(group => group.entityId === entityId && parentEntity == group.entity)) {
              groups.push({ entityId, key, oldData, newData, createdAt, entity: parentEntity, children: [] });
          }
          
            const group = groups.find(group => group.entityId === entityId && group.entity == parentEntity);
            if(group) {
                group.children.push({ entityId, entity, oldData, newData, createdAt, clientName, action, userName, id });
            
            }
                
          return groups;
      }, []);
  };


    /**
     * Default load — fetches all logs for TODAY (scoped to current calendar day).
     * Uses /fetchlogs with today's date range so the initial load is bounded.
     */
    const handleGetAllLogs = async() => {
        dispatch(requestShowLoader());
        try {
           const today = moment().format("YYYY-MM-DD");
            const payload = {                  
              createdAtFrom : today,
              createdAtTo : today
            }
             await dispatch(handleRequestSearchAuditLogs(payload));

        } catch (error) {
            enqueueSnackbar(handleValidateCodevalue(internationalise, "COMMON_PLEASE_TRY_AGAIN"), { variant: 'error' });
        } finally {
            dispatch(requestHideLoader());
        }
    }


    const handleGetEntityLogs = async () => {
        dispatch(requestShowLoader());
        try {
            const entitiesList = getEntityList(entityDetails);
            if (!entitiesList || entitiesList.length === 0) {
                setoriginalRecord([]);
                setDatagridData([]);
                return;
            }

            const queryparam = getQueryStrinngFromObject({
                entity: entitiesList,
                entityId: entityDetails?.entityId,
            });

            const url = `${process.env.REACT_APP_BASE_URL}audit/fetchlogs?${queryparam}`;
            const { data } = await getRequestData(url);

            // In embedded mode we are already on the specific entity page,
            // so grouping into parent/child hierarchy is redundant.
            // Show a flat, time-sorted list of log entries directly.
            const flatData = (data || [])
                .map(item => ({ ...item, key: item?.id }))
                .sort((a, b) => new Date(b?.createdAt) - new Date(a?.createdAt));

            setoriginalRecord(data || []);
            setDatagridData(flatData);
        } catch (error) {
            enqueueSnackbar(handleValidateCodevalue(internationalise, "COMMON_PLEASE_TRY_AGAIN"), { variant: 'error' });
        } finally {
            dispatch(requestHideLoader());
        }
    };

    const [dialogData, setdialogdata] = useState({
        isOpen: false,
        data: null
    });


    const handleViewLogs = (id) => {
      dispatch(requestShowLoader());
      try {
        const filtereddata = originalrecord.find(item => item?.id == id);
        setdialogdata({
            isOpen: true,
            data: filtereddata
        });
      }
      finally{
        dispatch(requestHideLoader());
      }
    }


    const columns = [
        {
            key: 'entityId',
            title: handleValidateCodevalue(internationalise, "AUDI_SEARCH_REF_ID"),
            dataIndex: "entityId",
            flex: 1,
            editable: false,
            width: 200,
            
        },
        {
          key: 'entity',
          title: handleValidateCodevalue(internationalise, "AUDI_SEARCH_ENTITY"),
          dataIndex: 'entity',
          flex: 1,
          editable: false,
        },

        {
          key: 'action',
          title: handleValidateCodevalue(internationalise, "AUDI_SEARCH_ACTION"),
          flex: 1,
          editable: false,
          dataIndex: 'action',
          
        },
        {
          key: 'userName',
          title: handleValidateCodevalue(internationalise, "AUDI_SEARCH_ACTION_BY"),
          flex: 1,
          editable: false,
          dataIndex: 'userName',
         
        },
       
        {
          key: 'createdAt',
          title: handleValidateCodevalue(internationalise, "AUDI_SEARCH_ACTION_AT"),
          type: 'date',
          dataIndex: 'createdAt',
          flex: 1,
          editable: false,
          render: (text, record) => !record?.children?.length > 0 && formatDateForDisplay(text),
        },
        {
            key: 'id',
            title: handleValidateCodevalue(internationalise, "AUDI_SEARCH_VIEW_LOG"),
            dataIndex: "id",
            width: 100,
            render: (id, record) => !record?.children?.length > 0 &&
            <Tooltip title = {handleValidateCodevalue(internationalise, "AUDI_SEARCH_VIEW_LOG")}>
            <RemoveRedEyeIcon
             className="audit-view-icon" onClick={() => {handleViewLogs(id)}}/>
             </Tooltip>
             ,
           }
      ];
    

      const handleClose = () => {
            setdialogdata(null);
      }

      const handleResetSearch = async() => {
        setInputSearch({
            entityId: null,
            entity: null,
        });

        setRequiredError({
          entityId: false,
          entity: false,
        });

        handleGetAllLogs(); 
      }

      const handleSearch = async() => {

        // Entity is required; entityId is optional (searching by entity alone searches all-time)
        if (inputSearch?.entity) {
            dispatch(requestShowLoader());
            try {
                var entitiesList = await getEntityList(inputSearch);

                const payload = {
                    ...inputSearch, 
                    entity: entitiesList
                }

                setRequiredError({
                  entityId: false,
                  entity: false,
                });

                await dispatch(handleRequestSearchAuditLogs(payload));
            } catch (error) {
                enqueueSnackbar(handleValidateCodevalue(internationalise, "COMMON_PLEASE_TRY_AGAIN"), { variant: 'error' });
            } finally {
                dispatch(requestHideLoader());
            }
        } else {

            setRequiredError({
              entityId: false,
              entity: true,
            });

            enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_AUDIT_SEARCH_WARNING"), {variant: "warning"});
          
        }

    }

      const handleChangeSearchField = (event) => {
        setInputSearch({
            ...inputSearch,
            [event.target.name]: event.target.value
        });
      }

      const headerleabel = useCallback(() => {
       return handleValidateCodevalue(internationalise, label)
      },[internationalise]);
      
      const handleParseData = (item) => {
          const {newData, oldData, ...entitydata} = item;
          return entitydata;
      }

      // Keys whose values are date/time and should be reformatted for display
      const DATE_DISPLAY_KEYS = new Set(['createdAt', 'updatedAt', 'followupDate', 'nextFollowupDate']);

      /**
       * Converts a raw date value to a human-readable IST string with AM/PM.
       * Handles:
       *   - epoch milliseconds (number)       e.g. 1746527085291
       *   - UTC ISO with Z                    e.g. "2026-05-06T11:30:00Z"
       *   - ISO with offset                   e.g. "2026-04-01T12:55:05.291+00:00"
       *   - bare local datetime string        e.g. "2026-05-06T11:30:00" (treated as UTC)
       */
      const formatDateForDisplay = (value) => {
          if (value == null) return value;
          try {
              let date;
              if (typeof value === 'number') {
                  date = new Date(value);
              } else if (typeof value === 'string') {
                  // Already has timezone info (Z or ±HH:MM) → parse as-is
                  // Otherwise treat bare datetime as UTC by appending Z
                  const hasTimezone = value.endsWith('Z') || /[+-]\d{2}:\d{2}$/.test(value);
                  date = new Date(hasTimezone ? value : value + 'Z');
              } else {
                  return value;
              }
              if (isNaN(date.getTime())) return value;
              return date.toLocaleString('en-IN', {
                  timeZone: 'Asia/Kolkata',
                  day:    '2-digit',
                  month:  '2-digit',
                  year:   'numeric',
                  hour:   '2-digit',
                  minute: '2-digit',
                  second: '2-digit',
                  hour12: true,
              });
          } catch {
              return value;
          }
      };

      /**
       * Recursively walks data (object, array, or primitive) and formats
       * any known date key to IST AM/PM string — handles nested arrays like
       * leadFollowups[], and nested objects at any depth.
       */
      const enrichForDisplay = (data) => {
          if (data == null) return data;
          if (Array.isArray(data)) {
              return data.map(item => enrichForDisplay(item));
          }
          if (typeof data === 'object') {
              const copy = { ...data };
              Object.keys(copy).forEach(key => {
                  if (DATE_DISPLAY_KEYS.has(key)) {
                      copy[key] = formatDateForDisplay(copy[key]);
                  } else {
                      copy[key] = enrichForDisplay(copy[key]);
                  }
              });
              return copy;
          }
          // primitive — return as-is
          return data;
      };

      const isLoadingProgress = useSelector(state => state?.global?.isLoading);

    return (
      
        <div className="audit-page-container">
            <BiztantuLoader isChildren={true} open={isSearchRequired && isLoadingProgress}>
            <Typography variant='h6' className="audit-page-title">
              {headerleabel()}
            </Typography>

            <StyledIndexContainerDiv>
              {/* Show the search bar only on the standalone Audit Logs screen */}
              {isSearchRequired && (
                <StyledLeadContainer className="audit-search-panel">
                  <Stack className='table-header-search table-header-search-common'>
                    <BiztantuSearch
                      showStatus={false}
                      showDates={false}
                      entityDetails={inputSearch}
                      handleReset={handleResetSearch}
                      handleSearch={handleSearch}
                      maxWidth="sm">
                      <AuditSearch
                        handleChangeSearchField={handleChangeSearchField}
                        auditvalue={inputSearch}
                        requiredError={requiredError}
                      />
                    </BiztantuSearch>
                  </Stack>
                  <Stack className='secondry-btn-container' width="60%" padding="10px" justifyContent="flex-end" spacing={2} direction="row">
                  </Stack>
                </StyledLeadContainer>
              )}
                        

            <Table
              sticky={true}
              columns={columns}
              size='middle'
              // loading={loading}
              expandable={{
                expandedRowKeys,
                onExpand: (expanded, record) => {
                    setExpandedRowKeys(expanded ? [record.key] : []);
                },
                expandIcon: ({ expanded, onExpand, record }) =>
                  record?.children?.length > 0 &&
                  (expanded ? (
                    <ArrowDropDownIcon className="audit-expand-icon" onClick={(e) => onExpand(record, e)}/>
                  ) : (
                    <ArrowRightIcon className="audit-expand-icon" onClick={(e) => onExpand(record, e)}/>
                  ))
                }}
              dataSource={datagridData}
            />

          </StyledIndexContainerDiv>
            </BiztantuLoader>
            {dialogData?.isOpen && <GeneralDialog
              open={dialogData?.isOpen}
              size="lg"
              title={dialogData?.data?.entity}
              handleClose={handleClose}
            >
              {/* Entity + Reference ID header row above diff viewer */}
              <Stack className="audit-detail-header">
                <Typography variant="body2">
                  <strong>Entity:</strong>&nbsp;{dialogData?.data?.entity ?? '—'}
                </Typography>
                <Typography variant="body2">
                  <strong>Reference ID:</strong>&nbsp;{dialogData?.data?.entityId ?? '—'}
                </Typography>
              </Stack>

              <StyledflexSpacebetween>
                  <ReactDiffViewer
                    oldValue={JSON.stringify(enrichForDisplay(dialogData?.data?.oldData), null, 2)}
                    newValue={JSON.stringify(enrichForDisplay(dialogData?.data?.newData), null, 2)}
                    splitView={true}
                    showDiffOnly={true}
                    leftTitle={"OldData"}
                    rightTitle={"NewData"}
                  />
              </StyledflexSpacebetween>
                
            </GeneralDialog>}
        </div>
    )
}


export default AuditLogs;
